module.exports = __webpack_public_path__ + "static/bigquote-f39951ef88cf85672fce9ac0cad0cb69.jpg";